export default __webpack_public_path__ + "locales/fr/Common.json?hash=da7580a746abed4266bd2c40c90e1a7c";